import { cloneDeep } from "lodash-es";
import { useGetLogin } from '@/hooks/shopify-hooks/api/useLoginApi';
import { storefrontCustomerApi } from '@/hooks/shopify-hooks/api/useStoreFrontCustormer';
import { _CSR_SHOP_CART_ID, _CSR_ACCESS_TOKEN, _CSR_LOGIN_EMAIL } from '@/const/shopifyConst';
import { useSetStorage, useGetStorage } from '@/hooks/common/useStorage';
import { useCustomerName } from '@/hooks/shopify-hooks/useShopifyMessageEvent';
import { useDispatchGAEvent } from '@/hooks/common/useDispatchGAEvent';
import { isPhonePortrait } from "@/hooks/common/useUtils";
import { shopifyConst } from '@/hooks/shopify-hooks/useShopifyConst.js';
const { c4aOAuth2State} = shopifyConst;
const c4aOAuth2StateNew = c4aOAuth2State === 'true' ? true : false;
// const { loginPath} = useGetPath();
// console.log('loginPath',loginPath)
// 判断元素是否存在
export const eleIsExist = (ele, cb) => {
  const dom = document.querySelector(ele);
  if (ele && dom !== null) {
    cb && cb(dom);
  }
  return;
};

/**
 * 从当前页面地址中剔除查询参数，返回不含 ? 及其后内容的 URL
 * @returns {string} 协议 + 域名 + 路径（末尾不带 ? 和查询字符串）
 * @example
 * // 当前地址 https://example.com/page?user=123&tab=info
 * const cleanUrl = getUrlWithoutParams();
 * console.log(cleanUrl); // "https://example.com/page"
 */
export const getUrlWithoutParams = () => {
  const url = new URL(window.location.href);
  return url.origin + url.pathname;
}

// uri 参数拼接
export const parseParams = (uri = "", params = {}) => {
  const paramsArray = [];
  const keys = Object.keys(params);
  if (keys.length === 0) {
    return uri;
  }
  keys.forEach(
    (key) => params[key] && paramsArray.push(`${key}=${params[key]}`)
  );
  if (uri.search(/\?/) === -1) {
    uri += `?${paramsArray.join("&")}`;
  } else {
    uri += `&${paramsArray.join("&")}`;
  }
  return uri;
};

// AEM uri 参数拼接, uri eg: '/content/midea-aem/us/productlist.data', params eg: {page: 1, pageSize: 20}
export const parseAEMParams = (uri = "", params = {}) => {
  const keys = Object.keys(params);
  if (keys.length === 0) {
    return `${uri}.json`;
  }
  const paramsStr = keys
    .map((key) => params[key] && `${key}_${params[key]}`)
    .filter((item) => !!item)
    .join(".");
  return `${uri}.${paramsStr}.json`;
};

// 解析序列化后的数据
/* eslint-disable */
export const QueryParam = {
  /**
   * @param {String} url 解析的地址eg.https://test.com?a=1&b=2
   * @returns { a: 1, b: 2 }
   */
  parse: function (url) {
    const params = {};
    const queryString = url.split("?")[1];
    if (queryString) {
      const keyValuePairs = queryString.split("&");
      for (let i = 0; i < keyValuePairs.length; i++) {
        const keyValuePair = keyValuePairs[i].split("=");
        const key = decodeURIComponent(keyValuePair[0]);
        const value = decodeURIComponent(keyValuePair[1] || "");
        params[key] = value;
      }
    }
    return params;
  },
  /**
   *@param {Object} param : an object
   *@param {String} splitKey : 组合的key, 默认是&
   */
  parseToString: function (param, splitKey) {
    const arr = [];
    (param = param || {}), (splitKey = splitKey || "&");
    // eslint-disable-next-line
    for (const i in param) {
      arr.push(i + "=" + param[i]);
    }
    return arr.join(splitKey);
  },
};
/* eslint-disable */

/**
 * 处理根据指定的url参数key,修改其对应的url参数值
 * @param {string} key 指定的参数key
 * @param {string} paramVal 指定的参数要修改的值
 * @return {string} newUrl 新拼接的url
 */
export const handleUrlParams = (key, paramVal) => {
  // 获取当前 URL
  let url = window.location.href;

  // 将 URL 拆分成两部分：基础 URL 和查询字符串
  let parts = url.split("?");
  let baseUrl = parts[0];
  let queryString = parts?.[1]??"";
  let newQueryString = `${key}=${paramVal}`;

  if(queryString){
    // 将查询字符串拆分成参数数组
    let params = queryString?.split("&");

    // 遍历参数数组，查找名为 "key" 的参数
    for (let i = 0; i < params?.length; i++) {
      let parts = params[i].split("=");
      let name = parts[0];
      let value = parts[1];
      if (name === key) {
        // 如果找到了名为 "key" 的参数，则将其值替换为新值
        value = paramVal;
        params[i] = name + "=" + value;
        break;
      }
    }

    // 将参数数组重新组合成查询字符串
    newQueryString = params?.join("&");
  }

  // 将基础 URL 和新的查询字符串组合成新的 URL
  let newUrl = baseUrl + "?" + newQueryString;
  return newUrl;
};

// 解決author mode下跳转链接问题
export const getJumpLink = (url = "") => {
  const viewAsPublishUrlMark = "wcmmode=disabled";
  if (location.href.includes(viewAsPublishUrlMark)) {
    return `${url}?${viewAsPublishUrlMark}`;
  } else {
    return url;
  }
};

// 复制文本方法
export const handleCopy = (copyTxt, copyMsg) => {
  navigator.clipboard
    .writeText(copyTxt)
    .then(() => {
      window.igws.$toast.open({
        status: "success",
        text: copyMsg || "Copy successfully",
      });
    })
    .catch((err) => {
      window.igws.$toast.open({
        status: "error",
        text: "Copy failed",
      });
    });
};

/**
 * Formats a price according to the specified language and site.
 *
 * @param {number|string} price - The price to be formatted.
 * @param {string} lang - The language code (e.g. 'en', 'fr', 'de', 'it', 'vn').
 * @param {string} [site] - The site code (e.g. 'in' for India).
 * @returns {string} The formatted price.
 */
export const transformPrice = (price, lang, site) => {
  const type = lang + (site ? "_" + site : "");
  function en(price) {
    function commafy(num) {
      num = num + "";
      return num.replace(/^([^\.]*?\d)(\d+)/, function (s, a, b) {
        return a + b.replace(/(?=(\d{3})+$)/g, ",");
      });
    }
    return commafy(price);
  }
  const enPrice = en(price);
  const arr = enPrice.split(".");
  switch (type) {
    case "en":
      return enPrice;
    case "fr":
      return enPrice.replace(/,/g, " ").replace(".", ",");
    case "de":
      arr[0] = arr[0].replace(/,/g, ".");
      return arr.join(",");
    case "it":
      arr[0] = arr[0].replace(/,/g, ".");
      return arr.join(",");
    case "vn":
      return arr[0].replace(/,/g, ".");
    case "en_in":
      return enPrice.replace(/,/g, " ");
  }
};

// 获取跟环境、品牌相关的参数
export const getEnvConfig = () => {
  const envConfig = require("../../config/env");
  const { brandConfig } = envConfig;
  const { BRAND, RUNTIME_ENV } = process.env;
  return brandConfig[BRAND][RUNTIME_ENV];
};

// 执行所有函数
export const runFns = (fnList = []) => {
  fnList.forEach((fn) => fn());
};
// 前端异步加载JS资源，保证同一个url只被加载一次
export const importJSSDKSource = ({
  url, // 加载js url
  cb, // 回调函数
  onloadSleepFn, // 加载完毕后的延迟执行函数，需返回promise对象
  getSrcFn, // 获取资源链接的方法，有时候前端不知道资源的完整链接，又不知道渲染的script标签的id，就需要自定义一个方法去获取，方法里可能是根据资源的domain去获取
} = {}) => {
  try {
    if (!window.ASYNC_JSSDK) {
      window.ASYNC_JSSDK = {};
    }
    if (!window.ASYNC_JSSDK[url]) {
      window.ASYNC_JSSDK[url] = {
        loaded: false, // 资源未加载完毕
        callbacks: [], // 未加载完毕时的回调函数集合
      };
    }
    const asyncJSSDK = window.ASYNC_JSSDK[url]; // 当前加载JSSDK对象
    // JSSDK已加载，无需存储callback，直接执行回调
    if (asyncJSSDK.loaded) {
      return cb && cb();
    }
    // JSSDK未加载，存储callback
    else {
      cb && asyncJSSDK.callbacks.push(cb);
    }
    const script = document.createElement("script");
    script.src = url;
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;
    // JSSDK加载完毕，执行所有回调并清空，同时标记loaded为true
    script.onload = async function () {
      onloadSleepFn && (await onloadSleepFn()); // 部分sdk加载后需等待其执行内部逻辑
      runFns(asyncJSSDK.callbacks);
      asyncJSSDK.callbacks = null;
      window.ASYNC_JSSDK[url].loaded = true;
    };

    // insert to head
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
  } catch (err) {
    console.log(err);
  }
};


 /* 检查 HTML 根标签是否有 dir="rtl" 属性
 * @returns {boolean} 存在返回 true，否则返回 false
 */
export function hasRTLDirection() {
  const htmlElement = document.documentElement;
  return htmlElement.getAttribute('dir')?.toLowerCase() === 'rtl';
}

// 排序方法
export const sortData = (arr, key) => {
  let newArr = []
  if (arr.length) {
    newArr = cloneDeep(arr);

    // 提取数字（支持负数、小数）
    const getNum = (str) => {
      const match = String(str).match(/-?\d+(\.\d+)?/);
      return match ? Number(match[0]) : NaN;
    };

    newArr.sort((a, b) => {

      const aRaw = a[key] ?? '';
      const bRaw = b[key] ?? '';
      
      const aNum = getNum(aRaw);
      const bNum = getNum(bRaw);
      
      // 如果两个都能提取数字，直接数值排序（解决数字不准问题）
      if (!isNaN(aNum) && !isNaN(bNum)) {
        if (aNum !== bNum) {
          return aNum - bNum;
        }
      }

      const aValue = String(aRaw);
      const bValue = String(bRaw);

      const maxLength = Math.max(aValue.length, bValue.length);
      for (let i = 0; i < maxLength; i++) {
        const aCharCode = aValue.charAt(i)
          ? aValue.charAt(i).toUpperCase().charCodeAt(0)
          : -Infinity;
        const bCharCode = bValue.charAt(i)
          ? bValue.charAt(i).toUpperCase().charCodeAt(0)
          : -Infinity;

        if (aCharCode !== bCharCode) {
          return aCharCode - bCharCode;
        }
      }
      return 0;
    });
  }
  return newArr
};

// 新的断点配置，给新的自适应规则适用
const newBdBkPoint = {
  midea: {
    mb: {
      breakPoint: [, 767.9],
      base: null,
    },
    tablet: {
      breakPoint: [768, 1440.9],
      base: 1440,
    },
    large: {
      breakPoint: [1441,],
      base: null,
    },
  }
}
const useScreenMedia = ({ windowWidth, brand, bkPoint } = {}) => {
  const config = bkPoint || newBdBkPoint[brand];
  
  let type = null;
  if (!config) {
    return type;
  }

  for (let key in config) {
    const { breakPoint = [] } = config[key];
    if (!breakPoint.length) {
      break;
    }

    const [b1 = 0, b2 = Infinity] = breakPoint;
    if (windowWidth >= b1 && windowWidth <= b2) {
      type = key;
      break;
    }
  }
  
  return {
    type,
    config: config[type],
  };
}

const useCalcByScreenMedia = ({ windowWidth, screenMedia, num,isNeedUnit } = {}) => {
  if (!screenMedia) {
    const firstKey = Object.keys(num)[0];
    return num[firstKey];
  };

  const { config = {}, type } = screenMedia;

  if (!config.base) {
    return isNeedUnit ? num[type]+'px': num[type];
  } else {
    return isNeedUnit ? (num[type] * 100 / config.base)+'vw': (num[type] * windowWidth) / config.base;
  }
}

export const calcVw2 = ({ num = {}, brand = "", bkPoint } = {},isNeedUnit = false) => {
  if (!brand || !num) { return 0; }
  const windowWidth = window.innerWidth;
  const screenMedia = useScreenMedia({
    windowWidth,
    brand,
    bkPoint,
  });

  return useCalcByScreenMedia({
    windowWidth,
    screenMedia,
    num,
    isNeedUnit
  });
}

const getEmailFn = async (accessToken) =>{
  const res = await  storefrontCustomerApi.fetchCustomer(accessToken)
  console.log('resemail',res)
  if(res.email) {
    useSetStorage(_CSR_LOGIN_EMAIL, res.email);
    // 普通用户绑定公司信息到购物车里
    await updateCustomerCartBuyer(accessToken,res.email)

  }

}

const isInApp = () =>{
  return typeof window.NativeBridge !== 'undefined';
}

const updateCustomerCartBuyer = async (customerAccessToken, email) =>{
  const cartId = useGetStorage(_CSR_SHOP_CART_ID);
  const buyerIdentity = {
    customerAccessToken,
    email
  }
  if (cartId) {
    await updateCustomerCartBuyerIdentity(buyerIdentity, cartId.value);
  }
}
export const replacetokenC4a = () =>{
   // 同时检查 search 和 hash 中的 token 参数
   const searchParams = QueryParam.parse(window.location.search);
   const hash = window.location.hash;
   const hashQueryIndex = hash.indexOf('?');
   const hashAmpIndex = hash.indexOf('&');
   // 兼容两种 hash 参数格式：
   // #myaccount?token=xxx  → ? 后面解析
   // #myaccount&token=xxx  → & 后面解析（实际使用格式）
   let hashParams = {};
   if (hashQueryIndex !== -1) {
     hashParams = QueryParam.parse(hash.slice(hashQueryIndex));
   } else if (hashAmpIndex !== -1) {
     hashParams = QueryParam.parse('?' + hash.slice(hashAmpIndex + 1));
   }
   const token = searchParams.token || hashParams.token;
   console.log('getReplaceTokentoken',token)
   if (!token) return;





// url操作 从 search 中移除 token
delete searchParams.token;
const newSearch = QueryParam.parseToString(searchParams);
// 从 hash 中移除 token
delete hashParams.token;
const hashPath = hashQueryIndex !== -1
  ? hash.slice(0, hashQueryIndex)
  : (hashAmpIndex !== -1 ? hash.slice(0, hashAmpIndex) : hash);
const newHashSearch = QueryParam.parseToString(hashParams);
const newHash = `${hashPath}${newHashSearch ? `?${newHashSearch}` : ''}`;
  const isAccountPage = searchParams.account || false;
  if (isAccountPage) {
  delete searchParams.account;
}
const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}${newHash}`;
console.log(';newUrl',newUrl,hashQueryIndex,hash)
window.history.replaceState(null, '', newUrl);











}
export const getReplaceToken = async (loginPath,loginPathForMobile) => {
  if(c4aOAuth2StateNew) {
    replacetokenC4a()
    return
  }
  // 同时检查 search 和 hash 中的 token 参数
  const searchParams = QueryParam.parse(window.location.search);
  const hash = window.location.hash;
  const hashQueryIndex = hash.indexOf('?');
  const hashAmpIndex = hash.indexOf('&');
  // 兼容两种 hash 参数格式：
  // #myaccount?token=xxx  → ? 后面解析
  // #myaccount&token=xxx  → & 后面解析（实际使用格式）
  let hashParams = {};
  if (hashQueryIndex !== -1) {
    hashParams = QueryParam.parse(hash.slice(hashQueryIndex));
  } else if (hashAmpIndex !== -1) {
    hashParams = QueryParam.parse('?' + hash.slice(hashAmpIndex + 1));
  }
  const token = searchParams.token || hashParams.token;
  console.log('getReplaceTokentoken',token)
  if (!token) return;

 
  // 设置shopify token
  const res = await  useGetLogin(token)
  console.log('res',res,res?.data?.value?.accessToken)

  if(res?.data?.value?.accessToken) {
    useSetStorage(_CSR_ACCESS_TOKEN, res?.data?.value);
    useDispatchGAEvent('__GA_SIGN_IN_CLICK__');   
  }

   // H5交互
  if(isInApp() && token && res?.data?.value?.accessToken){
    // 传入c4a token 到 app ,只需要判断是否存在C4A
    window?.NativeBridge?.call?.('syncLogin', JSON.stringify({
      token
    }), (result) => {
      console.log("app login sync status:  ", result);
    });
  }
  const isAccountPage = searchParams.account || false;

  // url操作 从 search 中移除 token
  delete searchParams.token;
  const newSearch = QueryParam.parseToString(searchParams);
  // 从 hash 中移除 token
  delete hashParams.token;
  const hashPath = hashQueryIndex !== -1
    ? hash.slice(0, hashQueryIndex)
    : (hashAmpIndex !== -1 ? hash.slice(0, hashAmpIndex) : hash);
  const newHashSearch = QueryParam.parseToString(hashParams);
  const newHash = `${hashPath}${newHashSearch ? `?${newHashSearch}` : ''}`;
  if (isAccountPage) {
    delete searchParams.account;
  }
  const newUrl = `${window.location.pathname}${newSearch ? `?${newSearch}` : ''}${newHash}`;
  console.log(';newUrl',newUrl,hashQueryIndex,hash)
  window.history.replaceState(null, '', newUrl);
  if(!res?.data?.value?.accessToken){
    console.log('获取token失败 --')
    // token过期出错跳回去，避免本身cv过来的url携带了token
    if(!isInApp()) { // app端访问无需登录页面，不应该跳
      // 处理本地非app携带token进入非必须登录页面的url：https://sit-toshiba.midea.com/vn?token=xxx
      if(isPhonePortrait()){
        const urllogin = loginPathForMobile || loginPath
        if(handleResetPasswordLink(urllogin)) { // 带域名
          window.location.href = `${urllogin}${window.location.href}`
        } else {
          window.location.href = urllogin
        }
      } else {
        if(handleResetPasswordLink(loginPath)) { // 带域名
          window.location.href = `${loginPath}${window.location.href}`
        } else {
          window.location.href = loginPath
        }
      }
    }
    return;
  }
    
  // 设置email
  await getEmailFn(res?.data?.value?.accessToken)
  // 通知header更新用户名字
  await useCustomerName();

  // 如果 url 带有 account=true 参数，token 已写入 storage，无需刷新，直接交由 renderAllCsrCmp 挂载组件
 
  if(isAccountPage) {
    return;
  }
  // window.location.replace(newUrl);

  return token;
}
const  handleResetPasswordLink = (url)=> {
  // 判断是否带域名（http/https 开头）
  const hasDomain = /^https?:\/\//i.test(url);
  // 不带域名 → 不处理，直接返回 ,不带域名是false
  return hasDomain;
  
}


